import { Component, OnInit } from "@angular/core";
import { ViewWillEnter } from "@ionic/angular";
import { ActivatedRoute, Router } from "@angular/router";
import { CreateWorkOrderService } from "../../../../services/create-work-order.service";
import { WorkOrderProduct } from "../../../../models/work-order-product.model";
import { WorkOrderGarment } from "../../../../models/work-order-garment.model";
import { ToasterService } from "../../../../../../common/services/toaster.service";
import { GtrakAuthService } from "../../../../../authentication/services/gtrak-auth.service";
import { GarmentReportService } from "../../../../../../../app/features/garment-listing/services/garment-report.service";
import { GarmentReportDetail } from "../../../../../../../app/features/garment-listing/models/garment-report-detail.model";
import { GarmentReportSummary } from "../../../../../../../app/features/garment-listing/models/garment-report-summary.model";
import { GarmentReport } from "../../../../../../../app/features/garment-listing/models/garment-report.model";
import { ConfirmationPopupComponent } from '../../components/confirmation-popup/confirmation-popup.component';
import { ModalController } from '@ionic/angular';
@Component({
  selector: "app-create-work-order-page",
  templateUrl: "create-work-order.page.html",
  styleUrls: [
    "./create-work-order.page.scss",
    "../../../../styles/g-route.styles.scss",
  ],
})
export class CreateWorkOrderPage implements ViewWillEnter, OnInit {
  currentRoute: string;
  stopName: string;
  customerCode: string;
  departmentCode: string;
  employeeCode: string;
  isLoading = false;
  garment: GarmentReport = null;
  garmentSummary: GarmentReportSummary = null;
  garmentDetails: GarmentReportDetail = null;
  empName: string;
  loaded: boolean = false;
  showMessage: boolean = false;
  message: string = "";
disableBtn:boolean=false;
  garmentDetailsShow: boolean = false;

  woProductList: WorkOrderProduct[] = [];
  selectedWoProductList: WorkOrderProduct[] = [];

  woGarmentList: WorkOrderGarment[] = [];

  userId: string | number = null;

  type: string = "XI";
  breadcrumbs=[];
  routeStopName: string = "";

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private createWorkOrderService: CreateWorkOrderService,
    private toasterService: ToasterService,
    private gtrakAuthService: GtrakAuthService,
     private modalController: ModalController,
    private garmentReportService: GarmentReportService
  ) {
    this.currentRoute = null;
  }

  async ngOnInit(): Promise<void> {
    this.isLoading=true;
    this.currentRoute = this.router.url;
    this.stopName = this.route.snapshot.paramMap.get("id");
    this.employeeCode = this.route.snapshot.paramMap.get("eId");
    this.departmentCode = this.route.snapshot.paramMap.get("dId");
    this.customerCode = this.route.snapshot.paramMap.get("cId");
    this.empName = localStorage.getItem('empName');
    this.routeStopName = localStorage.getItem('stopName');
    this.breadcrumbs.push({ label: 'Home', url: '/route' });
    this.breadcrumbs.push({ label: 'Logsheet', url: '/route/logsheet' });
    this.breadcrumbs.push({ label: 'Stop', url: '/route/logsheet/stop/'+ localStorage.getItem('stopCode') });
    this.userId = await this.gtrakAuthService.user.id;

    this.loadNonReplace();
  }

  ionViewWillEnter(): void {}

  async submitCancelItem(): Promise<void> {
    //check if selected list is empty
    this.loaded=false;
    if (this.selectedWoProductList.length === 0) {
      this.showMessage=false;
          this.message="";
      this.toasterService.presentToast(
        "warning",
        "",
        "Please select at least one garment",
        3000
      );
       this.loaded=true;
      return;
    }
  const modal = this.modalController.create({
                    component: ConfirmationPopupComponent,
                    cssClass: "min-width-modal",
                    showBackdrop: true,
                    componentProps: {
                        workOrder:'Are you sure you would like to cancel this item?'
                    },
                    backdropDismiss: true,
                    keyboardClose: true,
                    swipeToClose: true,
                });
        
                (await modal).present();
                const {data} = await (await modal).onDidDismiss();
        
    //submit
    if(data){
    await this.createWorkOrderService
      .SubmitCancelItem(
        this.userId,
        this.customerCode,
        this.employeeCode,
        this.departmentCode,
        this.stopName,
        this.type,
        this.selectedWoProductList
      )
      .then((res) => {
        if (Number.isInteger(Number(res))) {
          this.toasterService.presentToast(
            "primary",
            "",
            "Cancel Item Work Order Created: " + res,
            3000
          );
          this.showMessage=true;
          this.message="Cancel Item Work Order Created: " + res;
          this.disableBtn=true;
          this.woProductList = this.woProductList.filter(w => !this.selectedWoProductList.map(w => w.code).includes(w.code));
         this.selectedWoProductList = [];
        } else {
          this.showMessage=false;
          this.message="";
          this.disableBtn=false;
          this.toasterService.presentToast("danger", "", `${res}`, 3000);
        }
      });
    }
      this.loaded=true;
  }

  GetReplaceItem(): void {
    //check if selected list is empty
    if (this.selectedWoProductList.length === 0) {
      this.showMessage=false;
          this.message="";
      this.toasterService.presentToast(
        "warning",
        "",
        "Please select at least one garment",
        3000
      );
       this.loaded=true;
      return;
    }
    this.router.navigate([`/route/logsheet/stop/${this.stopName}/employee-lookup/create-work-order/${this.customerCode}/${this.departmentCode}/${this.employeeCode}/replace`], {
      state: { selectedWoProductList: this.selectedWoProductList }
    });
  }

  async submitSizeChange(): Promise<void> {
  
    this.loaded=false;

    //check if selected list is empty
    if (this.selectedWoProductList.length === 0) {
       this.showMessage=false;
          this.message="";
      this.toasterService.presentToast(
        "warning",
        "",
        "Please select at least one garment",
        3000
      );
      this.loaded=true;
      return;
    }
    var isSizeSelected=true;
    //check if all selected sizes are filled
     this.selectedWoProductList.forEach((wo) => {
      if (
        wo.selectedSize === "" ||
        wo.selectedSize === null ||
        wo.selectedSize === undefined
      ) {
        this.toasterService.presentToast(
          "danger",
          "",
          "Please select size for each selected items",
          3000
        );
        isSizeSelected=false;
        this.loaded=true;
        return;
      }
    });  
      if (!isSizeSelected) {
        return; 
      }
           const modal =await  this.modalController.create({
                    component: ConfirmationPopupComponent,
                    cssClass: "min-width-modal",
                    showBackdrop: true,
                    componentProps: {
                        workOrder:'Are you sure you would like to change the size of this item?'
                    },
                    backdropDismiss: true,
                    keyboardClose: true,
                    swipeToClose: true,
                });
        
                (await modal).present();
                const {data} = await (await modal).onDidDismiss();
        
    //submit
    if(isSizeSelected && data){
    await this.createWorkOrderService
      .SubmitSizeChange(
        this.userId,
        this.customerCode,
        this.employeeCode,
        this.departmentCode,
        this.stopName,
        this.selectedWoProductList
      )
      .then((res) => {
        if (Number.isInteger(Number(res))) {
          this.toasterService.presentToast(
            "primary",
            "",
            "Rent Size Change Work Order Created: " + res,
            3000
          );
          this.showMessage=true;
          this.message="Rent Size Change Work Order Created: " + res;
         this.disableBtn=true;
        } else {
          this.showMessage=false;
          this.message="";
          this.toasterService.presentToast("danger", "", `${res}`, 3000);
        }
      });
    }
    this.loaded=true;
  }

  async submitGarmentReplace(): Promise<void> {
    //submit
    this.loaded=false;
    await this.createWorkOrderService
    .SubmitGarmentReplace(
      this.userId,
      this.stopName,
      this.garmentDetails.garmentCode
    )
    .then((res) => {
      if (res === 'Success') {
        this.toasterService.presentToast(
          'success',
          '',
          'Garment replaced successfully',
          3000
        );
      } else {
        this.toasterService.presentToast('danger', '', `${res}`, 3000);
      }
    });
    this.loaded=true;
  }

  woChange(event) {
    this.showMessage=false;
    this.message="";
    this.disableBtn=false;
    if (event.detail.value === "XC") {
      //empty selected list
      this.selectedWoProductList = [];
      //add all to selected list
      this.selectedWoProductList = this.woProductList;
      this.loadNonReplace();
    }
    if (event.detail.value === "XI") {
      //empty selected list
      this.selectedWoProductList = [];
      this.loadNonReplace();
    }
    if (event.detail.value === "RSC") {
      //empty selected list
      this.selectedWoProductList = [];
      this.loadNonReplace();
    }
    if (event.detail.value === "RC") {
      //empty selected list
      this.selectedWoProductList = [];
      this.loadReplace();
    }
  }

  loadNonReplace() {
    this.loaded = false;
    this.createWorkOrderService
      .GetWoProductList(
        this.customerCode,
        this.employeeCode,
        this.departmentCode
      )
      .then((res) => {
        this.woProductList = res;
        this.loaded = true;
      });
  }

  async loadReplace():Promise<void> {
    this.loaded = false;
    await this.createWorkOrderService
      .GetWoGarmentList(
        this.customerCode,
        this.employeeCode,
        this.departmentCode
      )
      .then((res) => {
        this.woGarmentList = res;
        this.loaded = true;
      });
       this.loaded = true;
  }

  addSelected(wo: WorkOrderProduct, event) {
    if (event.target.checked) {
      this.selectedWoProductList.push(wo);
    } else {
      //splice it out
      this.selectedWoProductList.splice(
        this.selectedWoProductList.indexOf(wo),
        1
      );
    }
  }

  changeSelectedSize(wo: WorkOrderProduct, event) {
    //remove spaces
    wo.selectedSize = event.detail.value.replace(/\s/g, "");
  }

  showDetailsReplace(event) {
    this.garmentDetailsShow = false;
    this.garment = null;
    this.garmentSummary = null;
    this.garmentDetails = null;
    this.garmentReportService
      .findForGarment(event.target.textContent)
      .then((res) => {
        this.garmentDetailsShow = true;
        this.garment = res;
        this.garmentSummary = this.garment.summary[0];
        //set garmentDetails to garment.details where garment.details.garmentCode === event.target.textContent
        this.garmentDetails = this.garment.details.filter(
          (garment) => garment.garmentCode === event.target.textContent
        )[0];
      });
  }

  navigateToGarment(garment: GarmentReportDetail): void {
    this.router.navigate([`/route/logsheet/stop/${this.stopName}/lookup/${garment.garmentCode}`], {
      state: { replace: true },
    });
  }
}
